module.exports = __webpack_public_path__ + "static/RyanParag-resume-c877b21848234f391b71e966e8a26d12.pdf";